module.exports = __webpack_public_path__ + "media/bootstrap-icons/book-47db938c.svg";